/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} System_Status_Degraded_LabelInputs */



/**
* | output |
* | --- |
* | "Degraded performance" |
*
* @param {System_Status_Degraded_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const system_status_degraded_label = /** @type {((inputs?: System_Status_Degraded_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<System_Status_Degraded_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eingeschränkte Leistung")
	return /** @type {LocalizedString} */ ("Degraded performance")
});